import { useState } from 'react';

import { AxiosPrivate } from '../utils/axios';
import { serializeResponsesFormValues } from '../utils/responses';
import { WebSiteRoutes } from '../constants';

export const useAddOrUpdateResponsesForm = () => {
  const [isFetching, setFetching] = useState(false);

  const submit = async (
    values: any,
    type: string,
    organization: any,
    proponent: any,
    review: any,
    isAutoSave = false,
    lateOverride = false,
  ) => {
    try {
      if (!isAutoSave) {
        setFetching(true);
      }

      const request = serializeResponsesFormValues(values, type, organization, proponent, review, lateOverride);

      if (request.create.length || request.update.length) {
        const res = await AxiosPrivate.put('/responses/batch', request);
        if (isAutoSave) {
          return res;
        }
      }

      if (!isAutoSave) {
        window.open(`${WebSiteRoutes.ReviewDetails.replace(':reviewId', values.reviewId)}`, '_self');
      }

      return null;
    } catch (e) {
      // TODO: display alert
    } finally {
      setFetching(false);
    }
  };

  return {
    isFetching,
    submit,
  };
};
